import _ from 'lodash';
import React from 'react';
import { ThemeContext } from 'styled-components';
import classNames from 'classnames';
import ScrollTransition from '../../shared/scroll-transition';
import Header from '../../layout/navbar/mobile-navbar-elements/header';
import Drawer from '../../layout/navbar/mobile-navbar-elements/drawer';
import ErrorBoundary from '../../../shared/error-boundary';
import MobileNavbarContext from '../../layout/navbar/mobile-navbar-context';
import buildStaticMenus from '../../layout/navbar/mobile-navbar-elements/static-menus';

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'toggle':
      return { ...state, expanded: payload };
    case '_setExpandableMenus': {
      const s = { ...state };
      s.menus[payload.name] = payload.data;
      return s;
    }
    default:
      throw new Error();
  }
};

function actionMapper(hrefFunc) {
  return d => ({
    text: d.name,
    anchor: { href: hrefFunc(d) },
  });
}

export default function HeaderMobile() {
  const [scroll, setScroll] = React.useState({
    top: true, // navbar maximised
    up: false, // navbar scrolling up
    down: false, // navbar scrolling down
  });

  const {
    isUserSignedIn, categoriesData, seriesData, eventsData,
  } = React.useContext(ThemeContext);

  const [state, dispatch] = React.useReducer(reducer, {
    expanded: false,
    menus: buildStaticMenus(isUserSignedIn),
  });

  React.useEffect(() => {
    if (_.get(categoriesData, 'categories.length')) {
      dispatch({
        type: '_setExpandableMenus',
        payload: {
          name: 'Categories',
          data: categoriesData.categories.map(actionMapper(d => d.url)),
        },
      });
    }
  }, [categoriesData]);

  React.useEffect(() => {
    if (_.get(seriesData, 'series.length')) {
      dispatch({
        type: '_setExpandableMenus',
        payload: {
          name: 'Series',
          data: seriesData.series
            .map(datum => ({ ...datum, name: datum.title }))
            .map(actionMapper(d => d.url)),
        },
      });
    }
  }, [seriesData]);

  React.useEffect(() => {
    if (_.get(eventsData, 'events.length')) {
      dispatch({
        type: '_setExpandableMenus',
        payload: {
          name: 'Events',
          data: eventsData.events.map(actionMapper(d => `/events/${d.slug}`)),
        },
      });
    }
  }, [eventsData]);

  function updateScrollPosition(currentPosition, previousPosition) {
    setScroll({
      top: currentPosition <= 0,
      down: currentPosition > previousPosition,
      up: currentPosition < previousPosition && currentPosition > 0,
    });
  }

  return (
    <ErrorBoundary>
      <MobileNavbarContext.Provider value={{ state, dispatch }}>
        <nav className={classNames('mobile-navbar', {
          '--scrolling-down': scroll.down,
          '--scrolling-up': scroll.up,
        })}
        >
          <Header isUserSignedIn={!!isUserSignedIn} />
          {state.expanded
            ? <Drawer />
            : <ScrollTransition onScroll={updateScrollPosition} />}
        </nav>
      </MobileNavbarContext.Provider>
    </ErrorBoundary>
  );
}
